import React from 'react';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { chartColours } from '../../../core/constants/colours.constants';
import Paper from '@mui/material/Paper';

interface ParticipantCountCardProps {
  title: string;
  blurb: string;
  description: string;
  stat: string;
}

function ParticipantCountCard({ title, blurb, description, stat }: ParticipantCountCardProps) {
  return (
    <Paper
      elevation={4}
      sx={{
        height: '100%',
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          px: { xs: 2.5, md: 3 },
          pt: { xs: 2.5, md: 3 },
          pb: 2,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 46,
              height: 46,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'secondary.lighter',
              color: 'secondary.dark',
              flexShrink: 0,
              border: 1,
              borderColor: 'secondary.light',
            }}
          >
            <PeopleAltOutlined sx={{ fontSize: 30 }} />
          </Box>

          <Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {title}
            </Typography>

            <Typography variant="body2" component="p" color="text.secondary" sx={{ mt: 0.25 }}>
              {blurb}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ p: { xs: 2.5, md: 3 } }}>
        <Typography
          variant="h2"
          component="p"
          sx={{
            fontWeight: 900,
            lineHeight: 1,
            color: chartColours[2],
          }}
        >
          {stat}
        </Typography>

        <Typography variant="body2" component="p" color="text.secondary" sx={{ mt: 1 }}>
          {description}
        </Typography>
      </Box>
    </Paper>
  );
}

export default ParticipantCountCard;
